import React from 'react'
import { useFormContext } from 'react-hook-form'

import { RadioButton } from '../baseInputs'

type TProps = {
  optional?: boolean
}

const CompanyType = ({ optional, ...rest }: TProps) => {
  const { formState, getFieldState } = useFormContext()
  const { error } = getFieldState('company_type', formState)

  return (
    <div>
      <p className="font-medium mt-5 mb-1">
        {rest?.label || 'How many vehicles does your company run?'}{' '}
        {optional && (
          <span className="text-xs lowercase whitespace-nowrap">
            (optional)
          </span>
        )}
      </p>
      <div className="radio-btn-container flex gap-2 flex-col mb-5">
        <RadioButton
          name="company_type"
          value="sme"
          errorDisabled
          {...rest}
          label={rest?.radiolabels ? rest.radiolabels[0] : '1-25 vehicles'}
        />
        <RadioButton
          name="company_type"
          value="corporate"
          errorDisabled
          {...rest}
          label={rest?.radiolabels ? rest.radiolabels[1] : '26+ vehicles'}
        />
        {error && (
          <p className="text-red text-tiny mt-1" role="alert">
            {error.message}
          </p>
        )}
      </div>
    </div>
  )
}

export default CompanyType
